import AzureAD from './azuread';

function install(Vue, config) {
    var azure = new AzureAD(config);

    // interceptor to augment the request with the auth token
    Vue.http.interceptors.push(function (request, next) {
        if (!request.headers.map.authorization || request.headers.map.authorization.length === 0) {
            const account = azure.getAccount();

            if (account && account.idToken) {
                request.headers.set('Authorization', 'Bearer ' + account.idToken);
            }
        }
        next();
    });

    // interceptor for unauthorized responses
    Vue.http.interceptors.push(function (request, next) {
        next(function (res) {
            // Unauthorized Access
            if (
                res.status === 401 &&
                ['UnauthorizedAccess', 'InvalidToken', 'Unauthorized'].indexOf(res.data) > -1
            ) {
                console.warn('NOT authorized');
                // redirect to login route
                Vue.router.push({ path: '/login' });
            } else if (res.status === 500) {
                Vue.router.push({ name: 'error' });
            }
        });
    });

    Object.defineProperties(Vue.prototype, {
        $azure: {
            get() {
                return azure;
            }
        }
    });
}

export default install;
